import React, { Component } from 'react'
import {Helmet} from "react-helmet";
import '../styles/UpComing.css'

export default class UpComing extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Upcoming Courses</title>
                </Helmet>
                <div className="upComing inner">
                    <div className="container">
                        <h5><i class="fas fa-angle-double-right"></i> Upcoming Courses</h5>
                        <div className="row">
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons one">
                                        <i className="fas fa-globe"></i>
                                    </div>
                                    <div className="num">01</div>
                                    <div className="name name1">French</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons two">
                                        <i className="fas fa-code"></i>
                                    </div>
                                    <div className="num">02</div>
                                    <div className="name name2">Angular js</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons three">
                                        <i class="fas fa-palette"></i>
                                    </div>
                                    <div className="num">03</div>
                                    <div className="name name3">Photoshop</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons four">
                                        <i className="fas fa-edit"></i>
                                    </div>
                                    <div className="num">04</div>
                                    <div className="name name4">Writing</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons five">
                                        <i className="fas fa-globe"></i>
                                    </div>
                                    <div className="num">05</div>
                                    <div className="name name5">English</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons sex">
                                        <i className="fas fa-code"></i>
                                    </div>
                                    <div className="num">06</div>
                                    <div className="name name6">Vue js</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons seven">
                                        <i class="fas fa-palette"></i>
                                    </div>
                                    <div className="num">07</div>
                                    <div className="name name7">Graphic</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="upcoming-course">
                                    <div className="icons eight">
                                        <i className="fas fa-edit"></i>
                                    </div>
                                    <div className="num">08</div>
                                    <div className="name name8">Writing</div>
                                    <p className="info">
                                        Lorem Ipsum is simply dummy text of 
                                        the printing and typesetting industry. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
